module.exports = __webpack_public_path__ + "img/exit_blue.9597c0e6.svg";